import { Accordion, AccordionDetails, AccordionSummary, Box, Grid, Typography, Button, Paper, useTheme } from '@mui/material'
import React from 'react'
import ReactECharts from "echarts-for-react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Loading from '../Loading';
import { applyEChartsTheme } from '../../themes/echartsTheme';

const ChartDataAccordion = ({ expanded, handleAccordionChange, chartData, fetchFunctions, partsLoaded, initialQuery }) => {
    const theme = useTheme();
    const { gender, ageAndGender, adi } = chartData;
    const showGenderData = () => {
        if (!partsLoaded.genderChart) return <Loading />;
        if (gender?.response == "Retry" || typeof gender?.response !== 'object') return <Button color="error" onClick={() => fetchFunctions.fetchGenderDistributionData(initialQuery)}>Retry</Button>;

        return (
            <ReactECharts
                style={{
                    height: "250px",
                }}
                option={applyEChartsTheme(gender?.response, theme)}
                theme={"walden"}
            />
        )
    }

    const showAgeAndGenderData = () => {
        if (!partsLoaded.ageAndGenderChart) return <Loading />;
        if (ageAndGender?.response == "Retry" || typeof ageAndGender?.response !== 'object') return <Button color="error" onClick={() => fetchFunctions.fetchAgeDistributionData}>Retry</Button>;

        return (
            <ReactECharts
                style={{
                    height: "250px",
                }}
                option={applyEChartsTheme(chartData?.ageAndGender?.response, theme)}
                theme={"walden"}
            />
        )
    }

    const sortAdiOption = (option) => {
        if (!option?.yAxis?.data || !option?.series?.[0]?.data) return option;
        const getLevelOrder = (name) => {
            if (!name) return 999;
            const match = String(name).match(/Level\s+(\d+)/i);
            return match ? parseInt(match[1]) : 998;
        };
        const paired = option.yAxis.data.map((label, i) => ({
            label,
            series: option.series[0].data[i],
        }));
        paired.sort((a, b) => getLevelOrder(b.series?.name) - getLevelOrder(a.series?.name));
        return {
            ...option,
            yAxis: { ...option.yAxis, data: paired.map(p => p.label) },
            series: [{
                ...option.series[0],
                data: paired.map(p => p.series),
                label: {
                    ...option.series[0].label,
                    formatter: (params) => Number(params.value).toLocaleString(),
                },
            }],
        };
    };

    const showAdiScoreData = () => {
        if (!partsLoaded.adiChart) return <Loading />;
        if (adi?.response == "Retry" || typeof adi?.response !== 'object') return <Button color="error" onClick={() => fetchFunctions.fetchAdiScoreDistributionData}>Retry</Button>;

        return (
            <ReactECharts
                style={{
                    height: "250px",
                }}
                option={applyEChartsTheme(sortAdiOption(adi?.response), theme)}
                theme={"walden"}
            />
        )

    }
    return (
        <Accordion
            expanded={expanded === "chartData"}
            onChange={handleAccordionChange("chartData")}
            disabled={Object.keys(gender).length === 0 && Object.keys(ageAndGender).length === 0 && Object.keys(adi).length === 0}
        >
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                className="accordion-summary"
            >
                <Typography
                    variant="h6"
                    width={"100%"}
                    className="accordian-title"
                >
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            fontSize: "1rem",
                        }}
                    >
                        <Grid size={4}
                            sx={{
                                paddingLeft: "12px",
                            }}
                        >
                            Age Distribution
                        </Grid>
                        <Grid size={4}
                            sx={{
                                borderLeft: `1px solid ${theme.palette.divider}`,
                                borderRight: `1px solid ${theme.palette.divider}`,
                                paddingLeft: "12px",
                            }}
                        >
                            Gender Distribution
                        </Grid>
                        <Grid size={4}
                            sx={{
                                paddingLeft: "12px",
                            }}
                        >
                            ADI Score
                        </Grid>
                    </Box>
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container spacing={1}>
                    <Grid size={4}>
                        <Paper
                            sx={{
                                border: `1px solid ${theme.palette.divider}`,
                                backgroundColor: theme.palette.background.paper,
                                boxShadow: theme.palette.appShadow.card,
                                minWidth: "30%",
                            }}
                        >
                            <Box padding={1}>
                                <Typography
                                    sx={{
                                        fontSize: "0.87rem",
                                        color: theme.palette.text.secondary,
                                        fontWeight: 400,
                                    }}
                                >
                                    Age Data
                                </Typography>
                                {showAgeAndGenderData()}
                            </Box>
                        </Paper>
                    </Grid>
                    <Grid size={4}>
                        <Paper
                            sx={{
                                border: `1px solid ${theme.palette.divider}`,
                                backgroundColor: theme.palette.background.paper,
                                boxShadow: theme.palette.appShadow.card,
                                minWidth: "30%",
                            }}
                        >
                            <Box padding={1}>
                                <Typography
                                    sx={{
                                        fontSize: "0.87rem",
                                        color: theme.palette.text.secondary,
                                        fontWeight: 400,
                                    }}
                                >
                                    Gender Data
                                </Typography>
                                {showGenderData()}
                            </Box>
                        </Paper>
                    </Grid>
                    <Grid size={4}>
                        <Paper
                            sx={{
                                border: `1px solid ${theme.palette.divider}`,
                                backgroundColor: theme.palette.background.paper,
                                boxShadow: theme.palette.appShadow.card,
                                minWidth: "30%",
                            }}
                        >
                            <Box padding={1}>
                                <Typography
                                    sx={{
                                        fontSize: "0.87rem",
                                        color: theme.palette.text.secondary,
                                        fontWeight: 400,
                                    }}
                                >
                                    ADI Score
                                </Typography>
                                {showAdiScoreData()}
                            </Box>
                        </Paper>
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    )
}

export default ChartDataAccordion
